<template>
  <div>
    <div class="header relative">
      <p>欢迎使用生涯咨询中心预约系统!</p>
      <span  @click="changLink('/message')">
        <el-badge v-if="homeInfo.latestMsgsNum && homeInfo.latestMsgsNum !== 0" :value="homeInfo.latestMsgsNum" :max="99" class="headerDropdown">
        消息&nbsp;&nbsp;&nbsp;
        </el-badge>
      </span>
    </div>
    <el-card class="box-card">
      <div class="title clear">
        <h4 class="fl">公告</h4>
      </div>
      <ul class="mesList">
        <li v-for="notice in homeInfo.latestNotices" :key="notice.id" class="mesli">
          <el-button type="info" round size="mini" style="border: none; margin-right: 12px">{{ notice.fromUnit }}</el-button>
          <span @click="enterNotice(notice)" style="cursor: pointer">{{ notice.title }}</span>
        </li>
      </ul>
    </el-card>
    <el-card class="box-card">
      <div class="title clear" @click="changLink('/questAssign?code=0')">
        <h4 class="fl">指派测评</h4>
        <small class="fr">更多</small>
      </div>
      <ul class="mesList" v-if="homeInfo.assignQuests && homeInfo.assignQuests.length>0">
        <li v-for="(assignQuest,index) in homeInfo.assignQuests" :key="index" class="mesli">
          <span>
<!--            <i class="el-icon-star-on" style="color: red" />&nbsp;&nbsp;-->
            <el-badge is-dot class="mark" />&nbsp;
            {{ assignQuest }} </span>
          <a class="fr" style="color: red" @click="changLink('/questAssign?code=1')">[开始]</a>
        </li>
      </ul>
      <ul class="mesList" v-else>（无）</ul>
    </el-card>
    <el-card class="box-card">
<!--      @click="changLink('/myMes')-->
      <div class="title clear">
        <h4 class="fl">待办</h4>
      </div>
      <ul class="mesList" v-if="homeInfo.reserveSchedules && homeInfo.reserveSchedules.length>0">
        <li v-for="schedule in homeInfo.reserveSchedules" :key="schedule.id" class="mesli">
          <span>
<!--            <i class="el-icon-star-on" style="color: red" />&nbsp;&nbsp;-->
            <el-badge is-dot class="mark" />&nbsp;
            咨询师：{{schedule.teacher.teacherName}}，给你预留了1个预约：{{ schedule.planDate }}
            {{ schedule.planStartTime }}-{{schedule.planEndTime}}</span>
          <a v-if="canConfirm(schedule)" class="fr" style="color: red" @click="confirmSchedule(schedule)">[处理]</a>
        </li>
      </ul>
      <ul class="mesList" v-else>（无）</ul>
    </el-card>
    <el-card class="box-card">
      <div class="title clear" @click="changLink('/appointView')">
        <h4 class="fl">近期咨询</h4>
        <small class="fr">更多</small>
      </div>
      <ul class="mesList" v-if="homeInfo.latestSchedules && homeInfo.latestSchedules.length>0">
        <li v-for="schedule in homeInfo.latestSchedules" :key="schedule.id" class="mesli">
          <span>{{ schedule.planDate }} {{ schedule.planStartTime }}-{{schedule.planEndTime
            }}，{{ schedule.room.name }}，{{schedule.teacher.teacherName}}</span>
        </li>
      </ul>
      <ul class="mesList" v-else>（无）</ul>
      <el-button type="primary" round style="width: 100%" @click="goappointStep1">我要预约</el-button>
    </el-card>
    <el-card class="box-card">
      <span class="linkInner" @click.prevent="dialogContactShow = true">
        <i class="el-icon-phone iconmr"></i>联系预约员
      </span>
      <span class="linkInner text-right fr" @click.prevent="goGuide">
        <i class="el-icon-s-order iconmr"></i>来访者咨询指南
      </span>
    </el-card>
    <DialogContact v-if="dialogContactShow" :operatorContact="homeInfo.operatorContact" @close-contact="closeContact"></DialogContact>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HttpRequest from "@/utils/request";
import { formatTimeToStr } from "@/utils/date.js";
import DialogContact from '@/components/dialogContact'
export default {
  components: {
    DialogContact,
  },
  data() {
    return {
      dialogContactShow: false,
      homeInfo: {},
      partner: null,
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
	beforeMount() {
    this.$bus.$on('close-confirm', this.closeConfirm)
	},
  mounted() {
    document.title = '生涯咨询预约中心'
    this.partner = this.$route.query.partner;
    this.getHomeInfo();
  },
  methods: {
    handleSelect(index, indexPath) {
      this.$router.push(index);
    },
    goGuide() {
      this.$router.push("visitorConGuide");
    },
    goappointStep1() {
      this.$router.push("appointStep1");
    },
    handleCommand(command) {
      if (command === "logout") {
        store.dispatch("setLoginStatus", 0);
        this.$router.push("login?partner="+this.partner);
      }
    },
    getHomeInfo() {
      let url = "/constub/getHomeInfo";
      let data = { token: this.student.token };
      HttpRequest.requestFormPost(url, data).then((res) => {
        if (res && res.result.success) {
          this.homeInfo = res.data;
        } else {
          this.$message({
            message: res.result.message,
            type: "error",
          });
        }
      });
    },
    canConfirm(schedule){
      const now = new Date().getTime();
      const after24hour = schedule.planCreateTime + 24*60*60*1000;
      return now > schedule.planCreateTime && now < after24hour;
    },
    confirmSchedule(schedule) {
      // this.$router.push({ name: "appointReserve", params: { appoint: schedule } });
      this.$router.push('/appointReserve?scheduleId=' + schedule.id + '&pathfrom=home')
    },
    closeConfirm(){
      this.confirmShow = false;
    },
    changLink(link) {
      this.$router.push(link);
    },
    enterNotice(notice) {
      this.$alert(
        formatTimeToStr(notice.createTime) + " " + notice.content,
        notice.title,
        {
          confirmButtonText: "确定",
          showClose: false,
        }
      );
    },
    closeContact(){
      this.dialogContactShow = false;
    },
  },
};
</script>


<style scoped>
.headerDropdown {
  position: absolute;
  right: 20px;
  top: 0;
}
.mesList {
  clear: both;
  padding: 5px 0;
}
.mesList li {
  margin: 10px 0;
}
.mesList .el-button {
  padding: 5px 8px;
}
.linkInner {
  display: inline-block;
  width: 45%;
}


</style>
